<h2>National Artists</h2>
<ul class="credits-list credits-list--national">
  @for (credit of NATIONAL_CREDITS; track $index) {
    <li class="credits-list__item">{{ credit }}</li>
  }
</ul>

<h2>Washington DC &amp; Baltimore</h2>
<ul class="credits-list credits-list--local">
  @for (credit of DMV_CREDITS; track $index) {
    <li class="credits-list__item">{{ credit }}</li>
  }
</ul>

<h2>Atlanta</h2>
<ul class="credits-list credits-list--local">
  @for (credit of ATLANTA_CREDITS; track $index) {
    <li class="credits-list__item">{{ credit }}</li>
  }
</ul>
